<template>

  <el-row>
    <el-form ref="form" :model="form" size="small" label-width="160px">
      <el-row>
        <el-col :span="10">
          <el-form-item label="Ano/Mês">
            <el-col :span="8">
              <el-select v-model="form.ano" placeholder="Ano">
                <el-option
                  v-for="item in anos"
                  :key="item"
                  :label="item"
                  :value="item">
                </el-option>
              </el-select>
            </el-col>
            <el-col class="line text-center" :span="2">/</el-col>
            <el-col :span="11">
              <el-select v-model="form.mes" placeholder="Mês">
                <el-option
                  v-for="item in meses"
                  :key="item.mes"
                  :label="item.nome"
                  :value="item.mes">
                </el-option>
              </el-select>
            </el-col>
          </el-form-item>

          <el-form-item label="Indicador">
            <el-cascader style="width: 100%;"
                         filterable
                         v-model="form.indicador"
                         change-on-select
                         :options="indicadorlistTree"
                         :props="{label: 'nome' , value : 'id' }"
            ></el-cascader>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click.prevent="aplicar()">Aplicar</el-button>
          </el-form-item>
        </el-col>
        <el-col :span="14">
          <el-form-item label="Centro de Custo Pai">
            <el-select v-model="centroCustoParentId" placeholder="Centro de Custo Pai">
              <el-option
                v-for="item in centroCustoParentList"
                :key="item.id"
                :label="item.nome"
                :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-checkbox-group v-model="form.centroCustos">
              <el-checkbox v-for="child in centroCustoChildrens" :label="child.id" :key="child.id">{{child.nome}}</el-checkbox>
            </el-checkbox-group>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
  </el-row>
</template>

<script>
  import {mapGetters, mapState} from 'vuex'

  export default {
    name: "FilterGraph",
    props: ['showfilter'],
    computed: {
      ...mapGetters(['centroCustolistTree', 'indicadorlistTree', 'centroCustoParentList']),
      ...mapState(['anos', 'anoSelected', 'centroCustoList', 'meses', 'mesSelected']),
      centroCustoChildrens() {
        const list = collect(this.centroCustoList).where('parent_id', this.centroCustoParentId)
        this.form.centroCustos = [... list.pluck('id').all()]
        return list.all()
      }
    },
    data() {
      return {
        form: {
          centroCustos: [],
          ano: null,
          mes: null,
          indicador: null
        },
        centroCustoParentId: null,
        visible: false
      }
    },
    watch: {
      showfilter: function (val, oldVal) {
        this.visible = val;
      },
      visible: function (val, oldVal) {
        this.$emit('update:showfilter', val)
      }
    },
    methods: {
      aplicar() {
        const {anoFilterSelected} = this
        this.$emit('filtroAplicado', {
          ano: this.form.ano,
          mes: this.form.mes,
          centroCustos: [...this.form.centroCustos],
          indicador: _.last(this.form.indicador)
        })
        this.visible = false
      }
    },
    mounted() {
      this.anoFilterSelected = this.anoSelected
      this.centrosSelecteds = collect(this.centroCustoList).pluck('id').all()
    }
  }
</script>





// WEBPACK FOOTER //
// src/features/Dashboard/Components/Home/Graficos/IndicadorPorMetaFilter.vue